import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setK3Tasks, getK3Task } from '../../actions/k3taskAction';
import { getK3Agents } from '../../actions/k3agentAction';
import { getK3Scripts } from '../../actions/k3scriptAction';
import { withRouter } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Badge,
  InputGroup,
  Modal,
  ProgressBar,
  Toast,
  ToastContainer
} from 'react-bootstrap';
import { BsPencil, BsCheck2, BsX, BsTrash, BsCopy } from 'react-icons/bs';
import { getK3Docs } from '../../services/k3docService';

class K3TaskView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      task: props.selectedTask || { ...props.task },
      showDeleteConfirm: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      configFields: null,
      initialCustomType: null
    };
  }

  componentDidMount() {
    if (this.props.selectedTask) {
      this.setState({ task: this.props.selectedTask });
    } else {
      const { id } = this.props.match.params;
      if (id) {
        this.props.getK3Task(id);
      }
    }
    this.props.getK3Agents();
    this.props.getK3Scripts();

    // Fetch configFields for type select
    getK3Docs({ docMid: 'UI_CONFIG_FIELDS_K3TASK' })
      .then(response => {
        const data = response.data.data.docs;
        if (data && data.length > 0 && data[0].content) {
          try {
            const configFields = JSON.parse(data[0].content);
            this.setState({ configFields }, this.syncInitialCustomType);
          } catch (error) {
            console.error('Error parsing config fields:', error);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching config fields:', error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedTask && this.props.selectedTask !== prevProps.selectedTask) {
      this.setState({ task: this.props.selectedTask }, this.syncInitialCustomType);
    } else if (this.props.currentTask && this.props.currentTask !== prevProps.currentTask) {
      this.setState({ task: { ...this.props.currentTask } }, this.syncInitialCustomType);
    }
    if (
      prevState.task !== this.state.task ||
      prevState.configFields !== this.state.configFields
    ) {
      this.syncInitialCustomType();
    }
  }

  syncInitialCustomType = () => {
    const { task, configFields } = this.state;
    if (!configFields || !configFields.type) return;
    if (task && task.type && !configFields.type.options.some(opt => opt.value === task.type)) {
      this.setState({ initialCustomType: task.type });
    } else {
      this.setState({ initialCustomType: null });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      task: {
        ...prevState.task,
        [name]: value
      }
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { _id, ...taskData } = this.state.task;
      const updatedTask = {
        ...taskData,
        tags: Array.isArray(taskData.tags) ? taskData.tags : taskData.tags.split(',').map(tag => tag.trim()).filter(Boolean),
        input_data: typeof taskData.input_data === 'string' ? JSON.parse(taskData.input_data) : taskData.input_data,
        output_data: typeof taskData.output_data === 'string' ? JSON.parse(taskData.output_data) : taskData.output_data,
        metadata: typeof taskData.metadata === 'string' ? JSON.parse(taskData.metadata) : taskData.metadata
      };
      console.log(updatedTask);
      await this.props.setK3Tasks([{ _id, ...updatedTask }]);
      this.setState({ isEditing: false });
    } catch (error) {
      console.error('Error updating task:', error);
    }
  };

  toggleEdit = () => {
    this.setState(prevState => ({
      isEditing: !prevState.isEditing,
      task: { ...prevState.task }
    }));
  };

  handleDelete = async () => {
    try {
      const { _id } = this.state.task;
      await this.props.setK3Tasks([{ _id, is_deleted: true }]);
      this.setState({ showDeleteConfirm: false });
      if (this.props.onHide) {
        this.props.onHide();
      } else {
        this.props.history.push('/k3task');
      }
    } catch (error) {
      console.error('Error deleting task:', error);
    }
  };

  getStatusBadge = (status) => {
    const variants = {
      pending: 'secondary',
      running: 'primary',
      completed: 'success',
      failed: 'danger',
      cancelled: 'warning'
    };
    return <Badge bg={variants[status]}>{status}</Badge>;
  };

  getAgentName = (agentId) => {
    const agent = this.props.k3agents.find(a => a._id === agentId);
    return agent ? `${agent.name} (${agent.main_type} - ${agent.sub_type})` : agentId;
  };

  handleCopy = (text, fieldName) => {
    navigator.clipboard.writeText(text);
    this.setState({
      showToast: true,
      toastMessage: `${fieldName} copied to clipboard!`,
      toastType: 'success'
    });
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  };

  renderContent() {
    const { task, isEditing, configFields, initialCustomType } = this.state;
    const { k3agents, k3scripts } = this.props;

    // Helper to merge value into options if missing
    const mergeOptions = (options, customValue) => {
      let merged = options;
      if (customValue && !options.some(opt => opt.value === customValue)) {
        merged = [{ value: customValue, label: customValue }, ...options];
      }
      return merged;
    };

    // Helper to get label for type value
    const getTypeLabel = (value) => {
      if (configFields && configFields.type && configFields.type.options) {
        const found = configFields.type.options.find(opt => opt.value === value);
        return found ? found.label : value;
      }
      return value;
    };

    return (
      <>
        <Row className="mb-4">
          <Col>
            <h1>
              {isEditing ? (
                <Form.Control
                  type="text"
                  name="name"
                  value={task.name}
                  onChange={this.handleChange}
                  className="h1"
                />
              ) : (
                task.name || getTypeLabel(task.type)
              )}
            </h1>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>ID</Form.Label>
              <div style={{ position: 'relative' }}>
                <Form.Control
                  type="text"
                  value={task._id}
                  readOnly
                  style={{ paddingRight: '40px' }}
                />
                <Button 
                  variant="outline-secondary" 
                  onClick={() => this.handleCopy(task._id, 'ID')}
                  style={{
                    position: 'absolute',
                    right: '5px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: '0.25rem 0.5rem',
                    border: 'none',
                    background: 'transparent'
                  }}
                >
                  <BsCopy />
                </Button>
              </div>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Type</Form.Label>
              {isEditing ? (
                configFields && configFields.type ? (
                  <Form.Select
                    name="type"
                    value={task.type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Type</option>
                    {mergeOptions(configFields.type.options, initialCustomType).map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </Form.Select>
                ) : (
                  <Form.Control
                    type="text"
                    name="type"
                    value={task.type}
                    onChange={this.handleChange}
                  />
                )
              ) : (
                <Form.Control
                  type="text"
                  value={getTypeLabel(task.type)}
                  readOnly
                />
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Status</Form.Label>
              {isEditing ? (
                <Form.Select
                  name="status"
                  value={task.status}
                  onChange={this.handleChange}
                >
                  <option value="pending">Pending</option>
                  <option value="running">Running</option>
                  <option value="completed">Completed</option>
                  <option value="failed">Failed</option>
                  <option value="cancelled">Cancelled</option>
                </Form.Select>
              ) : (
                <div>{this.getStatusBadge(task.status)}</div>
              )}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Priority</Form.Label>
              {isEditing ? (
                <Form.Select
                  name="priority"
                  value={task.priority}
                  onChange={this.handleChange}
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </Form.Select>
              ) : (
                <Badge bg={task.priority === 'urgent' ? 'danger' : task.priority === 'high' ? 'warning' : 'info'}>
                  {task.priority}
                </Badge>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Source Agent</Form.Label>
              <div style={{ position: 'relative' }}>
                {isEditing ? (
                  <Form.Select
                    name="src_agent_id"
                    value={task.src_agent_id}
                    onChange={this.handleChange}
                    style={{ paddingRight: '40px' }}
                  >
                    <option value="">Select Source Agent</option>
                    {k3agents && k3agents.map(agent => (
                      <option key={agent._id} value={agent._id}>
                        {this.getAgentName(agent._id)}
                      </option>
                    ))}
                  </Form.Select>
                ) : (
                  <Form.Control
                    type="text"
                    value={this.getAgentName(task.src_agent_id)}
                    readOnly
                    style={{ paddingRight: '40px' }}
                  />
                )}
                <Button 
                  variant="outline-secondary" 
                  onClick={() => this.handleCopy(task.src_agent_id, 'Source Agent ID')}
                  style={{
                    position: 'absolute',
                    right: '5px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: '0.25rem 0.5rem',
                    border: 'none',
                    background: 'transparent'
                  }}
                >
                  <BsCopy />
                </Button>
              </div>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Target Agent</Form.Label>
              <div style={{ position: 'relative' }}>
                {isEditing ? (
                  <Form.Select
                    name="target_agent_id"
                    value={task.target_agent_id}
                    onChange={this.handleChange}
                    style={{ paddingRight: '40px' }}
                  >
                    <option value="">Select Target Agent</option>
                    {k3agents && k3agents.map(agent => (
                      <option key={agent._id} value={agent._id}>
                        {this.getAgentName(agent._id)}
                      </option>
                    ))}
                  </Form.Select>
                ) : (
                  <Form.Control
                    type="text"
                    value={this.getAgentName(task.target_agent_id)}
                    readOnly
                    style={{ paddingRight: '40px' }}
                  />
                )}
                <Button 
                  variant="outline-secondary" 
                  onClick={() => this.handleCopy(task.target_agent_id, 'Target Agent ID')}
                  style={{
                    position: 'absolute',
                    right: '5px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: '0.25rem 0.5rem',
                    border: 'none',
                    background: 'transparent'
                  }}
                >
                  <BsCopy />
                </Button>
              </div>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Script ID</Form.Label>
              <div style={{ position: 'relative' }}>
                {isEditing ? (
                  <Form.Select
                    name="script_id"
                    value={task.script_id}
                    onChange={this.handleChange}
                    style={{ paddingRight: '40px' }}
                  >
                    <option value="">Select Script</option>
                    {k3scripts && k3scripts.map(script => (
                      <option key={script._id} value={script._id}>
                        {script.title || script.name}
                      </option>
                    ))}
                  </Form.Select>
                ) : (
                  <Form.Control
                    type="text"
                    value={task.script_id}
                    readOnly
                    style={{ paddingRight: '40px' }}
                  />
                )}
                <Button 
                  variant="outline-secondary" 
                  onClick={() => this.handleCopy(task.script_id, 'Script ID')}
                  style={{
                    position: 'absolute',
                    right: '5px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: '0.25rem 0.5rem',
                    border: 'none',
                    background: 'transparent'
                  }}
                >
                  <BsCopy />
                </Button>
              </div>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Task Report ID</Form.Label>
              {isEditing ? (
                <Form.Control
                  type="text"
                  name="task_report_id"
                  value={task.task_report_id}
                  onChange={this.handleChange}
                />
              ) : (
                <Form.Control
                  type="text"
                  value={task.task_report_id}
                  readOnly
                />
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Parent Task ID</Form.Label>
              {isEditing ? (
                <Form.Control
                  type="text"
                  name="parent_task_id"
                  value={task.parent_task_id}
                  onChange={this.handleChange}
                />
              ) : (
                <Form.Control
                  type="text"
                  value={task.parent_task_id}
                  readOnly
                />
              )}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Children Task IDs</Form.Label>
              {isEditing ? (
                <Form.Control
                  type="text"
                  name="children_task_ids"
                  value={Array.isArray(task.children_task_ids) ? task.children_task_ids.join(', ') : task.children_task_ids}
                  onChange={this.handleChange}
                />
              ) : (
                <Form.Control
                  type="text"
                  value={Array.isArray(task.children_task_ids) ? task.children_task_ids.join(', ') : task.children_task_ids}
                  readOnly
                />
              )}
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-4">
          <Form.Label>Description</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="description"
                value={task.description}
                onChange={this.handleChange}
                rows={3}
                style={{ paddingRight: '40px' }}
              />
            ) : (
              <Form.Control
                as="textarea"
                value={task.description}
                readOnly
                rows={3}
                style={{ paddingRight: '40px' }}
              />
            )}
            <Button 
              variant="outline-secondary" 
              onClick={() => this.handleCopy(task.description, 'Description')}
              style={{
                position: 'absolute',
                right: '5px',
                top: '5px',
                padding: '0.25rem 0.5rem',
                border: 'none',
                background: 'transparent'
              }}
            >
              <BsCopy />
            </Button>
          </div>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Content</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="content"
                value={task.content}
                onChange={this.handleChange}
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            ) : (
              <Form.Control
                as="textarea"
                value={task.content}
                readOnly
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            )}
            <Button 
              variant="outline-secondary" 
              onClick={() => this.handleCopy(task.content, 'Content')}
              style={{
                position: 'absolute',
                right: '5px',
                top: '5px',
                padding: '0.25rem 0.5rem',
                border: 'none',
                background: 'transparent'
              }}
            >
              <BsCopy />
            </Button>
          </div>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Tags</Form.Label>
          {isEditing ? (
            <Form.Control
              type="text"
              name="tags"
              value={Array.isArray(task.tags) ? task.tags.join(', ') : task.tags}
              onChange={this.handleChange}
              placeholder="tag1, tag2, tag3"
            />
          ) : (
            <div>
              {Array.isArray(task.tags) ? task.tags.map(tag => (
                <Badge key={tag} bg="info" className="me-1">
                  {tag}
                </Badge>
              )) : task.tags}
            </div>
          )}
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Input Data</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="input_data"
                value={typeof task.input_data === 'string' ? task.input_data : JSON.stringify(task.input_data, null, 2)}
                onChange={this.handleChange}
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            ) : (
              <Form.Control
                as="textarea"
                value={typeof task.input_data === 'string' ? task.input_data : JSON.stringify(task.input_data, null, 2)}
                readOnly
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            )}
            <Button 
              variant="outline-secondary" 
              onClick={() => this.handleCopy(typeof task.input_data === 'string' ? task.input_data : JSON.stringify(task.input_data, null, 2), 'Input Data')}
              style={{
                position: 'absolute',
                right: '5px',
                top: '5px',
                padding: '0.25rem 0.5rem',
                border: 'none',
                background: 'transparent'
              }}
            >
              <BsCopy />
            </Button>
          </div>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Output Data</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="output_data"
                value={typeof task.output_data === 'string' ? task.output_data : JSON.stringify(task.output_data, null, 2)}
                onChange={this.handleChange}
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            ) : (
              <Form.Control
                as="textarea"
                value={typeof task.output_data === 'string' ? task.output_data : JSON.stringify(task.output_data, null, 2)}
                readOnly
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            )}
            <Button 
              variant="outline-secondary" 
              onClick={() => this.handleCopy(typeof task.output_data === 'string' ? task.output_data : JSON.stringify(task.output_data, null, 2), 'Output Data')}
              style={{
                position: 'absolute',
                right: '5px',
                top: '5px',
                padding: '0.25rem 0.5rem',
                border: 'none',
                background: 'transparent'
              }}
            >
              <BsCopy />
            </Button>
          </div>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Error Message</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="error_message"
                value={task.error_message}
                onChange={this.handleChange}
                rows={3}
                style={{ paddingRight: '40px' }}
              />
            ) : (
              <Form.Control
                as="textarea"
                value={task.error_message}
                readOnly
                rows={3}
                style={{ paddingRight: '40px' }}
              />
            )}
            <Button 
              variant="outline-secondary" 
              onClick={() => this.handleCopy(task.error_message, 'Error Message')}
              style={{
                position: 'absolute',
                right: '5px',
                top: '5px',
                padding: '0.25rem 0.5rem',
                border: 'none',
                background: 'transparent'
              }}
            >
              <BsCopy />
            </Button>
          </div>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Metadata</Form.Label>
          <div style={{ position: 'relative' }}>
            {isEditing ? (
              <Form.Control
                as="textarea"
                name="metadata"
                value={typeof task.metadata === 'string' ? task.metadata : JSON.stringify(task.metadata, null, 2)}
                onChange={this.handleChange}
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            ) : (
              <Form.Control
                as="textarea"
                value={typeof task.metadata === 'string' ? task.metadata : JSON.stringify(task.metadata, null, 2)}
                readOnly
                rows={5}
                style={{ paddingRight: '40px' }}
              />
            )}
            <Button 
              variant="outline-secondary" 
              onClick={() => this.handleCopy(typeof task.metadata === 'string' ? task.metadata : JSON.stringify(task.metadata, null, 2), 'Metadata')}
              style={{
                position: 'absolute',
                right: '5px',
                top: '5px',
                padding: '0.25rem 0.5rem',
                border: 'none',
                background: 'transparent'
              }}
            >
              <BsCopy />
            </Button>
          </div>
        </Form.Group>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Created At</Form.Label>
              <Form.Control
                type="text"
                value={new Date(task.createdAt).toLocaleString()}
                readOnly
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Updated At</Form.Label>
              <Form.Control
                type="text"
                value={new Date(task.updatedAt).toLocaleString()}
                readOnly
              />
            </Form.Group>
          </Col>
        </Row>
      </>
    );
  }

  render() {
    const { selectedTask, show, onHide, k3agents, k3scripts } = this.props;
    const { showDeleteConfirm, isEditing, showToast, toastMessage, toastType } = this.state;

    if (selectedTask) {
      return (
        <>
          <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton className="pl-5 pr-5">
              <div className="d-flex justify-content-between align-items-center w-100">
                <Modal.Title>Task Details</Modal.Title>
                <Button 
                  variant="primary" 
                  onClick={isEditing ? this.handleSubmit : this.toggleEdit}
                >
                  {isEditing ? (
                    <>
                      <BsCheck2 className="me-1" /> Save
                    </>
                  ) : (
                    <>
                      <BsPencil className="me-1" /> Edit
                    </>
                  )}
                </Button>
              </div>
            </Modal.Header>
            <Modal.Body className="pl-5 pr-5">
              {this.renderContent()}
            </Modal.Body>
            <Modal.Footer className="p-5 pt-0">
              <Button variant="danger" onClick={() => this.setState({ showDeleteConfirm: true })}>
                <BsTrash className="me-1" /> Delete
              </Button>
              <Button variant="secondary" onClick={onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showDeleteConfirm} onHide={() => this.setState({ showDeleteConfirm: false })}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this task? This action cannot be undone.
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => this.setState({ showDeleteConfirm: false })}>
                Cancel
              </Button>
              <Button variant="danger" onClick={this.handleDelete}>
                Delete
              </Button>
            </Modal.Footer>
          </Modal>

          <ToastContainer position="top-end" className="p-3">
            <Toast 
              show={showToast} 
              onClose={() => this.setState({ showToast: false })}
              bg={toastType}
              delay={3000}
              autohide
            >
              <Toast.Header closeButton={false}>
                <strong className="me-auto">Success</strong>
              </Toast.Header>
              <Toast.Body className="text-white">
                {toastMessage}
              </Toast.Body>
            </Toast>
          </ToastContainer>
        </>
      );
    }

    return (
      <Container className="py-4">
        {this.renderContent()}
      </Container>
    );
  }
}

const K3TaskViewWithRouter = (props) => {
  return <K3TaskView {...props} />;
};

const mapStateToProps = (state) => ({
  currentTask: state.k3taskReducer.currentTask,
  k3agents: state.k3agentReducer.k3agents,
  k3scripts: state.k3scriptReducer.scripts || []
});

export default connect(mapStateToProps, { 
  setK3Tasks, 
  getK3Task, 
  getK3Agents,
  getK3Scripts
})(withRouter(K3TaskViewWithRouter)); 